module.exports = {
  evaluate: require "./evaluate"
}



// WEBPACK FOOTER //
// ./src/Evaluator/Evaluator.coffee